// $(document).ready(function () {

//===============================================================================Headline-(Home-page) 
$('.headlines_wrapper').slick({
  infinite: true,
  slidesToShow: 8,
  arrows: false,
  variableWidth: true,
  dots: false,
  autoplay: true,
  autoplaySpeed: 0, 
  speed: 5000, 
  pauseOnHover: false,
  cssEase: 'linear', 
  responsive: [
    {
      breakpoint: 576,
      settings: {
        speed: 3000, 
      },
    },
  ],
});


 var swiper = new Swiper(".collection_mob_slider_wrapper", {
    slidesPerView: 5,
    spaceBetween: 10,
    breakpoints: {
      767: {
        slidesPerView: 6,
      },
      575: {
        slidesPerView: 4.1,
      },
      370: {
        slidesPerView: 4,
      },
      320: {
        slidesPerView: 3,
      },
    },
  });

//======================================================================Collection-Slider-(Home-page)
  var swiper_collection = new Swiper(".collection_slider_wrapper", {
    slidesPerView: 3,
    spaceBetween: 26,
    centeredSlides: true,
    speed: 300,
    loop: true,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".collection_slider .swiper-button-next",
      prevEl: ".collection_slider .swiper-button-prev",
    },
    on: {
      slideChange: updateButtonText,
      init: updateButtonText,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 38,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });

  function updateButtonText() {
    setTimeout(() => {
      var activeSlide = document.querySelector(".swiper-slide-active");
      var collectionTitle =
        activeSlide.querySelector(".collection_title").innerText;
      var collectionUrl = activeSlide.querySelector(".collection_url").href;

      var buttonContainer = document.getElementById("dynamic-button-container");
      buttonContainer.innerHTML = `
        <a href="${collectionUrl}" class="cmn_btn_1">Shop ${collectionTitle}</a>
      `;
    }, 300);
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Function to update the button text
    function updateCollectionButton(newTitle) {
      var button = document.getElementById("collectionButton");
      button.innerHTML = "shop " + newTitle;
    }

    // Example slider change event handler
    var slider = document.getElementById("yourSliderId"); // Replace with your actual slider ID
    if (!slider) return;

    slider.addEventListener("change", function () {
      var newTitle = "New Collection Title"; // Replace this with logic to get the new title
      updateCollectionButton(newTitle);
    });
  });

  // mobile menu header
  var mobMenuApIn = document.querySelector('.mob_menu_ap_in template'); 
  var appendMenuInne = document.getElementById('append_menu_inne'); 
  
  // Check karein agar elements exist karte hain
  if (mobMenuApIn && appendMenuInne) {
    
      appendMenuInne.innerHTML += mobMenuApIn.innerHTML; 
  } else {
      console.warn("Not Found.");
  }

//===========================================================================New-Arrival-(Home-page)
  var swiper_featured = new Swiper(".mySwiper.featured_collection_wrapper", {
    // slidesPerView: 3,
    // spaceBetween: 12,
    centeredSlides: true,
    slideToClickedSlide: true,
    speed: 800,
    loop: true,
    navigation: {
      nextEl: ".featured_collection_wrapper .swiper-button-next",
      prevEl: ".featured_collection_wrapper .swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 12,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 12,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 12,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 12,
        centeredSlides: false,
        loop: false,
      },
    },
  });

  //----new-arrival-tab-active
   $(".tabcollection_box_navlinks .featured_collection li").on(
    "click touchstart",
    function () {
      var tab_id = $(this).attr("data-tab");
  
      // Remove the active class from all nav items and add to the clicked item
      $(".tabcollection_box_navlinks .featured_collection li").removeClass(
        "swiper-slide-active"
      );
      $(this).addClass("swiper-slide-active");
  
      // Find the parent `.collection_tabify` and update product tab visibility
      var parentTab = $(this).closest(".collection_tabify");
      parentTab.find(".product_tab_details").removeClass("active").fadeOut();
  
      // Show and activate the corresponding tab
      var activeTab = $("#" + tab_id);
      activeTab.fadeIn("fast").addClass("active");
  
      // Update Swiper instance for the active tab
      var swiperInstance = activeTab.find(".mySwiper")[0]?.swiper;
      if (swiperInstance) {
        swiperInstance.update();
        updateActiveSlides(swiperInstance);
      }
    }
  );
  
  // Initialize Swiper for product tabs
  var product_tab_swiper = new Swiper(".product_tab_details.old_inner .mySwiper", {
    loop: false,
    centeredSlides: true,
    speed: 300,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".product_tab_details.old_inner .mySwiper .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".product_tab_details.old_inner .swiper-button-next",
      prevEl: ".product_tab_details.old_inner .swiper-button-prev",
    },
    on: {
      init: function () {
        updateActiveSlides(this);
        this.pagination.update();
      },
      slideChange: function () {
        updateActiveSlides(this);
      },
      paginationUpdate: function () {
        updateActiveSlides(this);
      },
      navigationNext: function () {
        updateActiveSlides(this);
      },
      navigationPrev: function () {
        updateActiveSlides(this);
      },
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: -20,
        centeredSlides: true,
        autoplay: true,
        loop: false,
      },
      576: {
        slidesPerView: 1.6,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: true,
        loop: false,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
        autoplay: false,
        loop: false,
      },
      992: {
        slidesPerView: 3.4,
        spaceBetween: 0,
        slidesOffsetAfter: -120,
        centeredSlides: false,
        autoplay: false,
        loop: false,
        pagination: false,
      },
      1200: {
        slidesPerView: 3.9,
        spaceBetween: 0,
        slidesOffsetAfter: -40,
        centeredSlides: false,
        autoplay: false,
        loop: false,
        pagination: false,
      },
      1441: {
        slidesPerView: 3.73,
        spaceBetween: 0,
        slidesOffsetAfter: -100,
        centeredSlides: false,
        autoplay: false,
        loop: false,
        pagination: false,
      },
    },
  });

//=======================================================================They-Love-it-(Home-page)
  var swiper_thay_love_it_wrapper = new Swiper(".thay_love_it_wrapper", {
    centeredSlides: true,
    loop: true,
    speed: 300,
    navigation: {
      nextEl: ".thay_love_it .swiper-button-next",
      prevEl: ".thay_love_it .swiper-button-prev",
    },
    pagination: {
      el: ".thay_love_it .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 1.5,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 1.9,
        spaceBetween: 40,
      },
      1441: {
        slidesPerView: 1.6,
        spaceBetween: 40,
      },
      1921: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });

//=========================================================About-page-slider
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
    if (!slick_is_animating) {
      var direction =
        Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

      // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

      if (direction > 0) {
        slick_instance.slick("slickNext");
      } else {
        slick_instance.slick("slickPrev");
      }
    }
  }

  // debounce the wheel event handling since trackpads can have a lot of inertia
  var slick_handle_wheel_event_debounced = debounce(
    slick_handle_wheel_event,
    100,
    true
  );

  function initSlick() {
    if ($(window).width() <= 767) {
      if (!$(".about_slider_wrapper").hasClass("slick-initialized")) {
        $(".about_slider_wrapper").slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          centerPadding: '20px',
          centerMode: true,
          slidesToShow: 1,
        });
      }

      if (
        !$(
          ".page-about-us .service_mobile_slider .halo-row.column-3"
        ).hasClass("slick-initialized")
      ) {
        $(
          ".page-about-us .service_mobile_slider .halo-row.column-3"
        ).slick({
          dots: true,
          arrows: false,
          infinite: false,
          speed: 300,
          centerMode: true,
          slidesToShow: 1,
        });
      }
    } else {
      if ($(".about_slider_wrapper").hasClass("slick-initialized")) {
        $(".about_slider_wrapper").slick("unslick");
      }

      if (
        $(
          ".page-about-us .service_mobile_slider .halo-row.column-3"
        ).hasClass("slick-initialized")
      ) {
        $(
          ".page-about-us .service_mobile_slider .halo-row.column-3"
        ).slick("unslick");
      }
    }
  }

  // Initialize on load
  initSlick();

  // Initialize on window resize
  $(window).resize(function () {
    initSlick();
  });

// }); //--------------------------------------Document-End

//==========================================Header-menu-Drawer
$(document).ready(function () {
  if ($(window).width() <= 1024) { 
    $('.menu-lv-1__action').click(function (event) {

      var $parent = $(this).closest('.menu-lv-1'); // Get the parent of the clicked action
      $('.menu_drop_1').not($(this).siblings('.menu_drop_1')).slideUp(500).parent().removeClass('isopen'); // Close other submenus and remove isopen
      $(this).siblings('.menu_drop_1').slideToggle(500);
      $parent.toggleClass('isopen'); // Toggle isopen class on the parent
    });

    $('.menu-lv-2__action').click(function (event) {
   
      var $parent = $(this).closest('.menu-lv-2'); // Get the parent of the clicked action
      $('.menu-lv__dropdownmenu-2').not($(this).siblings('.menu-lv__dropdownmenu-2')).slideUp(500).parent().removeClass('isopen'); // Close other submenus and remove isopen
      $(this).siblings('.menu-lv__dropdownmenu-2').slideToggle(500);
      $parent.toggleClass('isopen'); // Toggle isopen class on the parent
    });
  }
});

//====================================================================New-arrival-slider-active
function updateActiveSlides(swiper) {
  // Remove 'active' class from all slides
  swiper.slides.forEach(function (slide) {
    slide.classList.remove("active");
  });

  // Add 'active' class to currently visible slides
  for (var i = 0; i < swiper.params.slidesPerView; i++) {
    var slide = swiper.slides[swiper.activeIndex + i];
    if (slide) {
      slide.classList.add("active");
    }
  }
}

//=======================================Collection-Filter-js===========================

// $(document).ready(function(){
// $(".cm_filter_label").click(function(){
// $(".cm_filter-form").toggle(); // Hide/Show toggle
// });
// });

//_______________Filter-js-(desktop)
// $(document).ready(function () {
//   function applyFilterLogic() {
//     if ($(window).width() >= 992) {
//       // Filter Label Click Event
//       $('.cm_filter_label').on('click', function (e) {
//         e.stopPropagation();
//         $(this).toggleClass('filter-active');

//         // Smooth slide toggle for the filter form
//         $('.cm_filter-form').stop(true, true).slideToggle(600, 'swing').toggleClass('filter-form-active');

//         // Add or remove 'active' class on .collection-content
//         $('.collection-content').toggleClass('active');

//         // Add or remove 'filter_open' class on body
//         $('body').toggleClass('filter_open');
//       });

//       // Body Click Event for Removing Active Classes
//       $('body').on('click', function () {
//         if ($('.cm_filter_label').hasClass('filter-active')) {
//           $('.cm_filter_label').removeClass('filter-active');
//           $('.cm_filter-form').stop(true, true).slideUp(400, 'swing').removeClass('filter-form-active');
//           $('.collection-content').removeClass('active'); // Remove 'active' class from .collection-content
//           $('body').removeClass('filter_open'); // Remove 'filter_open' class from body
//         }
//       });

//       // Matching data-tab logic for '.cm_filter_tag li' and '.collection-sidebar__group-wrapper'
//       $('.cm_filter_tag li').on('click', function (e) {
//         e.stopPropagation(); // Prevent propagation to body click event

//         const selectedTab = $(this).attr('data-tab'); // Get the data-tab attribute from the clicked element

//         // Add 'filter_tag_active' class to the clicked li and remove from siblings
//         $(this).addClass('filter_tag_active').siblings().removeClass('filter_tag_active');

//         // Add 'filter_form_active' class to matching .collection-sidebar__group-wrapper and remove from others
//         $('.cm_filter-form .collection-sidebar__group-wrapper').each(function () {
//           if ($(this).attr('data-tab') === selectedTab) {
//             $(this).addClass('filter_form_active').siblings().removeClass('filter_form_active');
//           }
//         });
//       });

//       // Optional: Prevent clicks inside '.cm_filter-form' from closing the filter
//       $('.cm_filter-form, .collection-filter').on('click', function (e) {
//         e.stopPropagation();
//       });
//     }
//   }

//   applyFilterLogic();

//   // Re-run logic on window resize
//   $(window).on('resize', function () {
//     $('.cm_filter_label, .cm_filter_tag li, body').off(); // Remove previous event bindings
//     applyFilterLogic();
//   });
// });


//______________________Filter-js-(Mobile)
$(document).ready(function () {
  function applyFilterLogic() {
    if ($(window).width() <= 991) {
      // Filter Label Click Event
      $('.cm_filter_label').on('click', function (e) {
        e.stopPropagation();
        $(this).toggleClass('filter-active');

        // Smooth slide toggle for the filter form
        $('.cm_filter-form').stop(true, true).slideToggle(600, 'swing').toggleClass('filter-form-active');

        // Add or remove 'active' class on .collection-content
        $('.collection-content').toggleClass('active');

        // Add or remove 'filter_open' class on body
        $('body').toggleClass('filter_open');
      });

      // Body Click Event for Removing Active Classes
      $('body').on('click', function () {
        if ($('.cm_filter_label').hasClass('filter-active')) {
          $('.cm_filter_label').removeClass('filter-active');
          $('.cm_filter-form').stop(true, true).slideUp(400, 'swing').removeClass('filter-form-active');
          $('.collection-content').removeClass('active'); // Remove 'active' class from .collection-content
          $('body').removeClass('filter_open'); // Remove 'filter_open' class from body
        }
      });

      // Matching data-tab logic for '.cm_filter_tag li' and '.collection-sidebar__group-wrapper'
      $('.cm_filter_tag li').on('click', function (e) {
        e.stopPropagation(); // Prevent propagation to body click event

        const selectedTab = $(this).attr('data-tab'); // Get the data-tab attribute from the clicked element

        // Add 'filter_tag_active' class to the clicked li and remove from siblings
        $(this).addClass('filter_tag_active').siblings().removeClass('filter_tag_active');

        // Add 'filter_form_active' class to matching .collection-sidebar__group-wrapper and remove from others
        $('.cm_filter-form .collection-sidebar__group-wrapper').each(function () {
          if ($(this).attr('data-tab') === selectedTab) {
            $(this).addClass('filter_form_active').siblings().removeClass('filter_form_active');
          }
        });
      });

      // Optional: Prevent clicks inside '.cm_filter-form' from closing the filter
      $('.cm_filter-form, .collection-filter').on('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  applyFilterLogic();

  // Re-run logic on window resize
  $(window).on('resize', function () {
    $('.cm_filter_label, .cm_filter_tag li, body').off(); // Remove previous event bindings
    applyFilterLogic();
  });
});




//_______________Sort-js
document.addEventListener("DOMContentLoaded", function () {
  const sortButton = document.querySelector(".collection-filter__item--sort");
  const collectionContent = document.querySelector(".collection-content");

  if (sortButton && collectionContent) {
    // Sort button par click karva mate
    sortButton.addEventListener("click", function (event) {
      event.stopPropagation(); // Click event ne stop karo ke body par na jaye

      // Body ma `sort_open` class toggle karo
      document.body.classList.toggle("sort_open");

      // `.collection-content` ma `active` class toggle karo
      if (!collectionContent.classList.contains("active")) {
        collectionContent.classList.add("active");
      }
    });

    // Body par click karva mate
    document.addEventListener("click", function () {
      // `sort_open` class remove karo
      if (document.body.classList.contains("sort_open")) {
        document.body.classList.remove("sort_open");
      }

      // `.collection-content` ma `active` class check karo ane remove karo, jyaare already active naa hoy
      if (
        collectionContent.classList.contains("active") &&
        !sortButton.contains(event.target)
      ) {
        collectionContent.classList.remove("active");
      }
    });
  }
});






//======================
// $(".cm_filter_tag li").click(function () {
//   $(".cm_filter_tag li").removeClass('filter_tag_active'); 
//   $(this).addClass('filter_tag_active'); 

//   $(".filter-form div").removeClass('filter_form_active'); 
//   $(".filter-form div").addClass('filter_form_active'); 
// });

//================================================================ Collection Page Product img hover
$(document).ready(function () {
  $("body").on("mouseenter", ".grid-product__image-mask .image-wrap", function () {
    let $card = $(this);
    let $images = $card.find(".product-image");
    let $dotsContainer = $card.find(".dots-containerr");
    let $dots = $dotsContainer.find(".dot");
    let currentImageIndex = 0;

    let hoverInterval = setInterval(() => {
      $images.eq(currentImageIndex).removeClass("active");
      $dots.eq(currentImageIndex).removeClass("active");
      currentImageIndex = (currentImageIndex + 1) % $images.length;
      $images.eq(currentImageIndex).addClass("active");
      $dots.eq(currentImageIndex).addClass("active");
    }, 600);

    $card.data("hoverInterval", hoverInterval);
  });

  $("body").on("mouseleave", ".grid-product__image-mask .image-wrap", function () {
    let $card = $(this);
    let hoverInterval = $card.data("hoverInterval");
    clearInterval(hoverInterval);

    let $images = $card.find(".product-image");
    let $dotsContainer = $card.find(".dots-containerr");
    let $dots = $dotsContainer.find(".dot");

    $images.removeClass("active").eq(0).addClass("active");
    $dots.removeClass("active").eq(0).addClass("active");
  });
});

//=============================
// document.addEventListener('DOMContentLoaded', function() {
//     var elements = document.querySelectorAll('.grid-product__content');
//     var maxHeight = -1;

//     // Find the maximum height
//     elements.forEach(function(element) {
//         var height = element.getBoundingClientRect().height;
//         if (height > maxHeight) {
//             maxHeight = height;
//         }
//     });

//     // Set the minimum height for each .grid-product__content element
//     elements.forEach(function(element) {
//         element.style.minHeight = maxHeight + 'px';
//     });

//     // Set the height of .custom_img_1 equal to maxHeight
//     var customImage = document.querySelector('.custom_img_1');
//     if (customImage) {
//         customImage.style.height = maxHeight + 'px';
//     }
// });

  var swiper_custom_reviews_inner_wrapper = new Swiper(".custom_reviews_inner_wrapper",{
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".custom_reviews .swiper-button-next",
        prevEl: ".custom_reviews .swiper-button-prev",
      },
      pagination: {
        el: ".custom_reviews .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 1.5,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 1.7,
          spaceBetween: 40,
        },
        1441: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      },
    }
  );
  //---Toggle-custom-review
  $("#write_review").click(function () {
    $(".custom_reviews_button_wrapper_bottom").slideToggle("slow");
  });






 // Initialize Swiper for product tabs
  var product_tab_swiper = new Swiper(".product_tab_details.new_sec .mySwiper", {
    loop: false,
    centeredSlides: true,
    speed: 300,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".product_tab_details.new_sec .mySwiper .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".product_tab_details.new_sec .swiper-button-next",
      prevEl: ".product_tab_details.new_sec .swiper-button-prev",
    },
    on: {
      init: function () {
        updateActiveSlides(this);
        this.pagination.update();
      },
      slideChange: function () {
        updateActiveSlides(this);
      },
      paginationUpdate: function () {
        updateActiveSlides(this);
      },
      navigationNext: function () {
        updateActiveSlides(this);
      },
      navigationPrev: function () {
        updateActiveSlides(this);
      },
    },
    breakpoints: {
      200: {
        slidesPerView:1.4,
        spaceBetween: 0,
        centeredSlides: false,
            slidesPerColumn: 2,
        autoplay: true,
        loop: false,
      },
        380: {
        slidesPerView:2,
        spaceBetween: 0,
        centeredSlides: false,
            slidesPerColumn: 2,
        autoplay: true,
        loop: false,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
        autoplay: true,
          slidesPerColumn: 2,
        loop: false,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
        autoplay: false,
        loop: false,
      },
      992: {
        slidesPerView: 3.4,
        spaceBetween: 0,
        slidesOffsetAfter: -120,
        centeredSlides: false,
        autoplay: false,
        loop: false,
        pagination: false,
      },
      1200: {
        slidesPerView: 3.9,
        spaceBetween: 0,
        slidesOffsetAfter: -40,
        centeredSlides: false,
        autoplay: false,
        loop: false,
        pagination: false,
      },
      1441: {
        slidesPerView: 3.73,
        spaceBetween: 0,
        slidesOffsetAfter: -100,
        centeredSlides: false,
        autoplay: false,
        loop: false,
        pagination: false,
      },
    },
  });




